import { makeStyles } from '@material-ui/core/styles';
import { themeCommon } from '../../theme'


const useStyles = makeStyles((theme) => ({
    rootGridContainer: {
        // padding: '0 10px',
        margin: '10px 0',
    },
    rootAccordion: {
        boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.25)'
    },
    roundedAccordion: {
        borderRadius: '10px 10px 20px 20px',
        '&:last-child': {
            borderBottomLeftRadius: '20px',
            borderBottomRightRadius: '20px',
        },
        '&:first-child': {
            borderTopLeftRadius: '10px',
            borderTopRightRadius: '10px',
        }
    },
    rootAccordionSummary: {
        background: themeCommon.lightBlue,
        borderRadius: '10px 10px 10px 10px',
    },
    expandedAccordionSummary: {
        borderRadius: '10px 10px 0px 0px'
    },
    expandIconAccordionSummary: {
        color: '#FFFFFF',
    },
    contentAccordionSummary: {
        flexWrap: 'wrap',
    },
    rootContent: {
        color: '#FFFFFF',
        fontFamily: themeCommon.RobotoBold,
        fontSize: themeCommon.fontSize22px,
        textTransform: 'capitalize',
        width: '70%',
        [theme.breakpoints.down('lg')]: {
            fontSize: themeCommon.fontSize18px,
        },
        [theme.breakpoints.down('md')]: {
            fontSize: themeCommon.fontSize16px,
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: themeCommon.fontSize12px,
        },
    },
    secondaryHeading: {
        textAlign: 'end',
        width: '30%',
    },
    rootAccordionDetails: {
        flexDirection: 'column',
        borderRadius: '0px 0px 20px 20px',
        padding: '15px 10px',
    },
    rootGridItem: {
        marginBottom: '15px',
        boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.25)',
        borderRadius: '10px',
        background: '#FFFFFF',
        minHeight: '65px',
        padding: '0 20px',
        cursor: 'pointer',
        [theme.breakpoints.down('md')]: {
            padding: '0 10px',
        },
    },
    containerImage: {
        width: '60px',
    },
    learningContentTitle: {
        marginTop: '5px',
        color: '#2F2F2F',
        fontSize: themeCommon.fontSize18px,
        paddingLeft: '5px',
        width: 'calc(100% - 30px)',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxHeight: '20px',
        [theme.breakpoints.down('lg')]: {
            fontSize: themeCommon.fontSize16px,
        },
        [theme.breakpoints.down('md')]: {
            fontSize: themeCommon.fontSize14px,
            maxHeight: '16px',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: themeCommon.fontSize12px,
            maxHeight: '16px',
        },
    },
    learningContentCategory: {
        marginTop: '5px',
        color: '#2F2F2F',
        fontSize: themeCommon.fontSize12px,
        paddingLeft: '5px',
        width: 'calc(100% - 30px)',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxHeight: '12px',
        [theme.breakpoints.down('lg')]: {
            fontSize: themeCommon.fontSize10px,
        },
        [theme.breakpoints.down('md')]: {
            fontSize: themeCommon.fontSize8px,
            maxHeight: '10px',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: themeCommon.fontSize6px,
            maxHeight: '10px',
        },
    },
    rewardContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        width: 'calc(100% - 20px)',
    },
    iconContainer: {
        width: '20px',
    },
    rootGridPagination: {
        marginBottom: '10px',
    },
}), {
    name: 'LCRecommendHolderHeadContainer',
    index: 1,
})

export default useStyles